import loadItemsOnDateRangeChange from '../actions/loadItemsOnDateRangeChange';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { updateDateRangeType } from 'owa-calendar-surface';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import {
    updateNumDaysInDayRange,
    resetNumDaysInDayRange,
} from 'owa-calendar-surface-options-utils';

/**
 * Processes date range type change
 */
export async function processDateRangeTypeOrDayRangeChange(
    dateRangeType: DateRangeType,
    numOfDaysInDayRange: number = 1,
    forceUpdate: boolean = false,
    isUserChange: boolean = true
): Promise<void> {
    // force date range to update if requested or if number of days in range change
    const updateNumDays = dateRangeType === DateRangeType.Day;
    updateDateRangeType(
        dateRangeType,
        surfaceStore,
        numOfDaysInDayRange,
        forceUpdate || updateNumDays
    );
    if (updateNumDays && numOfDaysInDayRange != 1) {
        updateNumDaysInDayRange(numOfDaysInDayRange, isUserChange);
    } else {
        resetNumDaysInDayRange(isUserChange);
    }
    await loadItemsOnDateRangeChange(surfaceStore.dateRange, dateRangeType);
}
